import Markdown from 'react-markdown';

import { Container, ScrollContainer } from './styled';

type MarkdownTextProps = {
  children?: string;
};

// eslint-disable-next-line jsx-a11y/anchor-has-content, @typescript-eslint/no-explicit-any
const renderLink = (props: any) => <a {...props} target="_blank" rel="noopener noreferrer" />;

export default function MarkdownText({ children }: MarkdownTextProps) {
  return (
    <ScrollContainer>
      <Container>
        <Markdown
          components={{
            a: renderLink,
          }}
        >
          {children}
        </Markdown>
      </Container>
    </ScrollContainer>
  );
}
